import { render, staticRenderFns } from "./vertical.vue?vue&type=template&id=fc484b4a&"
import script from "./vertical.vue?vue&type=script&lang=js&"
export * from "./vertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports